import React from "react";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import { AdmHomePage } from "./ui/modules/Adm/HomePage";
import { LocalClientToken } from "./utils/local-client-token";
import { LocalAdmToken } from "./utils/local-adm-token";

import LoginPage from "./ui/modules/LoginPage";
import HomePage from "./ui/modules/HomePage";
import AssetPage from "./ui/modules/AssetsPage";
import SectionPage from "./ui/modules/SectionPage";
import UpdateAnomaliePosition from "./ui/modules/Adm/HomePage/UpdateAnomaliePosition";
import { AnomaliesPage } from "./ui/modules/Adm/HomePage/AnomaliesPage";
import { ReportsPage } from "./ui/modules/ReportsPage";
import { ReportsDetailsPage } from "./ui/modules/ReportsPage/ReportsDetails";
import ReportPrintPage from "./ui/components/ReportPrint";

const ProtectedRoute = ({ token, children }) => {
  if (!token) {
    return <LoginPage isAdmin={false} />;
  }
  return children;
};

const ProtectedAdmRoute = ({ admToken, children }) => {
  if (!admToken) {
    return <LoginPage isAdmin={true} />;
  }
  return children;
};

const RoutesApp = () => {
  const token = LocalClientToken.getStoredToken();
  const admToken = LocalAdmToken.getStoredToken();

  return (
    <>
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/login" element={<LoginPage isAdmin={false} />} />
          <Route path="/" element={<ProtectedRoute token={token}><HomePage /></ProtectedRoute>} />
          <Route path="/asset/:id" element={<ProtectedRoute token={token}><AssetPage /></ProtectedRoute>} />
          <Route path="/asset/:id/anomalies" element={<ProtectedRoute token={token}><AnomaliesPage /></ProtectedRoute>} />
          <Route path="/section/:id" element={<ProtectedRoute token={token}><SectionPage /></ProtectedRoute>} />
          <Route path="/reports/" element={<ProtectedRoute token={token}><ReportsPage /></ProtectedRoute>} />
          <Route path="/reports/:id" element={<ProtectedRoute token={token}><ReportsDetailsPage /></ProtectedRoute>} />
          <Route path="/print/:id" element={<ProtectedRoute token={token}><ReportPrintPage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>

      <BrowserRouter basename="/adm">
        <Routes>
          <Route path="/login" element={<LoginPage isAdmin={true} />} />
          <Route path="/" element={<ProtectedAdmRoute admToken={admToken}><AdmHomePage /></ProtectedAdmRoute>} />
          <Route path="/update-anomaly/:id" element={<ProtectedRoute token={token}><UpdateAnomaliePosition /></ProtectedRoute>} />
          <Route path="/anomalies/:fkRaffleId" element={<ProtectedRoute token={token}><AnomaliesPage /></ProtectedRoute>} />
          
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default RoutesApp;
